module.exports = __webpack_public_path__ + "img/yunxing.10f049ea.gif";